const PARTNERS = [
  {
    name: "TerniToday",
    img: "/logos/ternitoday.png",
    link: "https://www.ternitoday.it/",
  },
  {
    name: "PerugiaToday",
    img: "/logos/perugiatoday.png",
    link: "https://www.perugiatoday.it/",
  },
];

export function MediaPartnerStrip() {
  return (
    <section className="py-8 px-6 md:px-8 bg-white border-b border-[#e2e8f0]" data-testid="media-partner-strip">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-14">
        <span className="text-base md:text-lg font-ui font-bold text-[#0f172a] uppercase tracking-widest">
          Media Partner
        </span>
        {PARTNERS.map((p) => (
          <a
            key={p.name}
            href={p.link}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`media-partner-${p.name.toLowerCase()}`}
            className="hover:opacity-80 transition-opacity"
          >
            <img src={p.img} alt={p.name} className="h-8 md:h-10 w-auto object-contain" />
          </a>
        ))}
      </div>
    </section>
  );
}
